var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocuments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "url(#pattern0_7941_1466)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_7941_1466",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_7941_1466",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_7941_1466",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAACzUlEQVR4nO3Zu44TMRQGYDe8w84/SDTcKq4Vl8dA2oaaFyB2lnekZDNnaRASl4KLBJQgBUWskLIrJeNkMuf3+P8lF+mO/fnYThKCoiiKokw0SLbkGN2fo7k9D7UH7hBCWYs/glDW4g8glLX4L/75iPb70udox6G2wBvifLSpe3YJpcaLHgQYq7GqRSiBC0QogQ+kehQQglSNAlKQalEQ7T0ryHl9x1U9iY9enl5DtHesIFV2ytWTN9eb1H1gBakSpY2nNzxRetVYJ4p9ZAU5CIrnsYAek8DJ4qYHSs4aDoriD2HbUWJ3q4n2iRVkUBR/BOuNgmSfWUEGQ/EHsN4ozSu7PRbKLiCDoPgvvv0bPb9stTO7g9R9YQXZ+8ujO0T6X3DvSbTzs7tNtK+sIJtQigEJme0+BooLNFuhbQYKZmf3SkMpDiQbZf72fpPsm3f9kwbJRWni4kEpKGFbmAttc1Giffeex6RB8u+UxSOk7of3XCYNshuK/fSez6RBslFS95gVJWxLMYWGzDtlZk8Q7Zf3vCYNko0yt6dsKGFbSgNZJednlocvXl8JB4xAyP4+FQgZikDIUASy95OY/K4s8VLf5/8H+nl6F4iRF4CtHoEkgVDtSAhEINCRZeoQ76MAOrL8FxtDvGpGfvTolbVnBJLUIe7HCnRk7d6SwTnQpS4QMF/qo7TBhqhDBLKk7pDSRiCbr0AuRCBkOxJk9QS2AiGQukGGjjokCcR9l0Md4r+QEEiZZzIy66XfIKWfyRCIQKAOMXWI91kLHVn+iweB+L86IJDDvmrYRiCb7+jPTLYRyOYrkAsRCNmOBFk9ga1ACGQ/kOAcqEMEAuYja5Q22BB1iECW1B1S2gilxXvBIBCBUMd7B0MdIhDqeO9gqEMEQh3vHQx1iECo472DoQ4RCHW8dzDUIQKhjvcOhjpEINTx3sFQhyiKoihK2CV/AQ7gLxK0/ByKAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocuments);
export default __webpack_public_path__ + "static/media/documents.064b2a5ef16b23d56c49c7c4b9ff39d0.svg";
export { ForwardRef as ReactComponent };